import axios from 'axios'

function isPrismaError(error: { error: string }): boolean {
  return (
    error &&
    typeof error.error === 'string' &&
    error.error.includes('prismaClient')
  )
}

function getAxiosErrorMessage(error: unknown) {
  if (axios.isAxiosError(error)) {
    if (error.code === 'ERR_NETWORK') {
      return 'Erro de ligação, verifique a sua internet!'
    }

    if (error.response && error.response.data) {
      const errorData = error.response.data

      if (isPrismaError(errorData)) {
        return 'Ocorreu um erro no servidor.'
      }

      if (errorData.errors && Array.isArray(errorData.errors)) {
        const errorMessage = errorData.errors.join(', ')
        return errorMessage
      }

      if (errorData.error) {
        return errorData.error
      }

      if (errorData.message) {
        return errorData.message
      }
    }
  }

  return error
}

export { getAxiosErrorMessage }
